import React from 'react';
import Text from 'src/components/Text';
import styles from './styles.module.scss';
import robo from './robo.svg';

type Props = {
  title?: string;
  text?: string;
  code?: number;
};

const ErrorPlaceholder: React.FC<Props> = props => {
  const {
    title = 'Ошибка ',
    text = 'Данный сервис временно недоступен. Мы делаем все возможное, чтобы исправить эту проблему. Попробуйте повторить действие позже.',
    code = 500,
  } = props;

  return (
    <div className={styles['page']}>
      <div className={styles['error']}>
        <div>
          <p>
            {title}
            {code && <Text type="span" className={styles['code']}>{code}</Text>}
          </p>
          <div className={styles['message']}>{text}</div>
        </div>
        <img className={styles['image']} src={robo} alt="" />
      </div>
    </div>
  );
};

export default ErrorPlaceholder;
